export type {
  PopoverTriggerProps as TeachingPopoverTriggerProps,
  PopoverTriggerState as TeachingPopoverTriggerState,
  PopoverTriggerChildProps as TeachingPopoverTriggerChildProps,
} from '../../Popover/PopoverTrigger/PopoverTrigger.types';
